export const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "pourquoi-nous", label: "Pourquoi nous choisir" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
] as const;
